import { giftPassEmptyCopy } from './gift-passes-model';

export function GiftPassesEmptyState({ search, filtered }: { search: string; filtered: boolean }) {
  const copy = giftPassEmptyCopy(search, filtered);
  return (
    <div style={{ padding: '46px 20px', textAlign: 'center' }}>
      <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--nb-muted)', marginBottom: 4 }}>
        {copy.title}
      </div>
      <div style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>{copy.body}</div>
    </div>
  );
}
